export default "__VITE_ASSET__CC4g5b1o__"